import LangEnum from '../../../../lang/LangEnum';
import { ResourceType } from '../../../users/ability.types';
import { OrderListTabName } from '../../list/orderListTabs';
import { OrderHeadersGroupBy } from '../../products/orderProducts.types';

export enum ExportFormat {
  PDF = 'pdf',
  CSV = 'csv',
}

export enum ExportType {
  SINGLE_FILE = 'SINGLE_FILE',
  MULTIPLE_FILES = 'MULTIPLE_FILES',
}

export enum PageOrientation {
  PORTRAIT = 'PORTRAIT',
  LANDSCAPE = 'LANDSCAPE',
}

export enum ExportModel {
  COMPACT = 'COMPACT',
  STANDARD = 'STANDARD',
  DETAILED = 'DETAILED',
  ENLARGED = 'ENLARGED',
}

export enum SortBy {
  CODE = 'CODE',
  LAST_ADDED = 'LAST_ADDED',
  PRODUCT_NAME_A_Z = 'PRODUCT_NAME_A_Z',
  REFERENCE_CODE = 'REFERENCE_CODE',
}

export enum CsvTemplate {
  DEFAULT = 'DEFAULT',
  VERUP = 'VERUP',
  FILLED_MODEL = 'FILLED_MODEL',
}

export type ExportTabConfig = {
  value: ExportFormat;
  labelKey: LangEnum;
  exportType: '.pdf' | '.csv';
  Icon: React.ComponentType;
  disableWhenOffline?: boolean;
  ability?: ResourceType;
};
export type ExportScope =
  | { type: 'ids'; ids: string[] }
  | { type: 'filters'; filters: Record<string, unknown> };

export type ExportOrderScope = {
  scope: ExportScope;
  isSyncExport: boolean;
  selectedTab?: OrderListTabName;
};

export type OptionKeyed<T extends string = string> = {
  value: T;
  labelKey: LangEnum;
  description?: LangEnum;
};

export type GroupByOptions = {
  value: string;
  label: LangEnum;
};

export type ExportOrderForm = {
  format: ExportFormat;
  exportType: ExportType;
  createSummary: boolean;
  pageOrientation: PageOrientation;
  exportModel: ExportModel;
  groupBy?: OrderHeadersGroupBy;
  sortBy?: SortBy;
  showPriceComposition: boolean;
  showMarkupAndSellout: boolean;
  showSizePriceVariation: boolean;
  showSellInPrice: boolean;
  csvTemplate?: CsvTemplate;
  classificationTypeId?: string;
};
